import { Box, Center, Flex } from '@chakra-ui/react';
import { Drawer } from '@halo/ui-react';
import { GroupStatusEnum } from '@halo/chat-sdk-react';
import { CloseIcon } from '@halo/ui-chat-react';
import { useActionsStore } from '@/store/actions';
import GroupBg from './Profile/images/defaultBg.png';
import { FooterActions } from './Profile/footerActions';
import { ProfileContent } from './Profile/ProfileContent';
import { Header } from './Profile/Header';
import deleteImg from './Profile/images/deleteImg.png';

export function GroupDialog() {
  const { t } = useTranslation();
  const profileGroup = useActionsStore((state) => state.profileGroup);

  const { groupOpen, setGroupOpen } = useActionsStore();

  const isDeleteAccount = useMemo(() => {
    return (
      profileGroup?.status === GroupStatusEnum.DISBAND ||
      profileGroup?.status === GroupStatusEnum.Unknown
    );
  }, [profileGroup?.status]);

  return (
    <Drawer.Root open={groupOpen} onOpenChange={(details) => setGroupOpen(details.open)}>
      <Drawer.Backdrop />
      <Drawer.Positioner>
        <Drawer.Content w="560px" maxW="100%">
          <Drawer.Header className="Header" pt="5" px="5" pb="2.5" justifyContent="space-between">
            <Drawer.Title fontSize="md" fontWeight="semibold">
              {t('profile.groupTitle')}
            </Drawer.Title>
            <Center cursor="pointer" onClick={() => setGroupOpen(false)}>
              <CloseIcon />
            </Center>
          </Drawer.Header>
          <Drawer.Body
            className="scrollHover"
            p={0}
            bg={isDeleteAccount ? 'bg.subtle' : 'bg.subtle'}
          >
            <Box
              className="Box"
              w="full"
              bgImage={
                isDeleteAccount
                  ? 'linear-gradient(180deg, #f8f8f8 0%, #c5c5c5 100%)'
                  : `url(${GroupBg})`
              }
              bgSize="100% 100%"
              bgPos="center top"
              bgRepeat="no-repeat"
              h="252px"
            ></Box>
            <Header group={profileGroup} />
            {isDeleteAccount && (
              <Flex alignItems="center" flexDirection="column" gap="2">
                <img src={deleteImg} width="170px" height="100px"></img>
                <Box>{t('profile.groupNoExist')}</Box>
              </Flex>
            )}
            {!isDeleteAccount && (
              <Box px="5" minH="346px">
                <ProfileContent group={profileGroup} />
              </Box>
            )}
          </Drawer.Body>
          <Drawer.Footer
            overflow="hidden"
            justifyContent="start"
            px="4"
            bg="bg.subtle"
            rounded="xl"
          >
            {!isDeleteAccount && <FooterActions group={profileGroup!} />}
          </Drawer.Footer>
        </Drawer.Content>
      </Drawer.Positioner>
    </Drawer.Root>
  );
}
